import { motion } from "framer-motion";
import { FleurDivider } from "@/components/Ornament";

export const Reveal = ({ children, delay = 0, className = "", y = 44, style }) => (
  <motion.div
    className={className}
    style={style}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ number, text }) => (
  <div className="flex flex-col items-center mb-5" data-testid={`eyebrow-${number}`}>
    <FleurDivider id={`ornEyebrow-${number}`} size="w-5 h-5" className="mb-3 opacity-90" />
    <div className="flex items-center justify-center gap-3">
      <span className="h-px w-8 bg-gradient-to-r from-transparent to-amber-400/70" />
      <span className="font-cinzel text-[11px] sm:text-xs tracking-[0.35em] text-amber-300/90 uppercase">
        {number} — {text}
      </span>
      <span className="h-px w-8 bg-gradient-to-l from-transparent to-amber-400/70" />
    </div>
  </div>
);
